import * as React from "react";
import type { SVGProps } from "react";
const SvgSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="square_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666v597.334a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zm-128 42.666a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V213.333z"
    />
  </svg>
);
export default SvgSquareIcon;
